import gql from "graphql-tag";

export default gql`
  mutation confirmDistrictManualSetupTasks(
    $input: ConfirmDistrictManualSetupTasksInput
  ) {
    confirmDistrictManualSetupTasks(input: $input) {
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/_shared/gql/confirmDistrictManualSetupTasks.mutation.js